/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_FailedInputs */

const cs_jobs_status_failed = /** @type {(inputs: Jobs_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba`)
};

const en_jobs_status_failed = /** @type {(inputs: Jobs_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Jobs_Status_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_status_failed = /** @type {((inputs?: Jobs_Status_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_status_failed(inputs)
	return cs_jobs_status_failed(inputs)
});